<template>
  <div class="home">
    <menuBox :step="1"></menuBox>

    <div class="game-1">
      <div>Explore the wonderful world of games</div>
      <p>Recommend popular and classic games for you and bring you happiness in the world of games</p>
    </div>

    <div class="game-list">
      <div class="item-l">
        <img src="../assets/img-1.png" class="item-img-l">
        <div class="text-box">
          <div>Flying Bird</div>
          <p>Control the bird to move up and down by touching the screen. Make sure the bird does not hit the pillars. How many pillars can you pass through successfully?</p>
        </div>
      </div>
      <div class="item-r">
        <div class="item-box">
          <img src="../assets/img-2.png" class="item-img-l">
          <div class="text-box">
            <div>Classic Math</div>
            <p>There are numbers on the spheres. Click on the balls to make their sum equal to the target value. This game can help you as a puzzle guide. Come and try the fun of math games!</p>
          </div>
        </div>
        <div class="item-box">
          <img src="../assets/img-3.png" class="item-img-l">
          <div class="text-box">
            <div>Aircraft Wars</div>
            <p>Attack other unknown objects in the universe by moving the aircraft. Each time you shoot down an unknown object, you can earn points. Try out your dream of flying in the virtual world.</p>
          </div>
        </div>
      </div>
      <img src="../assets/image.png" class="image-t">
    </div>

    <div class="game-icon">
      <div class="item">
        <img src="../assets/icon-1.png" alt="">
        <div>Hot Recommendations</div>
        <p>Based on real-time download data, we have selected a list of popular games</p>
      </div>
      <div class="item">
        <img src="../assets/icon-2.png" alt="">
        <div>Convenient Jump</div>
        <p>Go directly to Google Play with one click and get games easily.</p>
      </div>
      <div class="item">
        <img src="../assets/icon-3.png" alt="">
        <div>Continuous Updates</div>
        <p>The list is updated in real time to ensure the latest games.</p>
      </div>
      <div class="item">
        <img src="../assets/icon-4.png" alt="">
        <div>Privacy Protection</div>
        <p>The third-party privacy policy is transparent and provides a safe and reliable experience.</p>
      </div>
    </div>

    <div class="game-info-box">
      <div class="title">Game Hot List</div>
      <div class="game-info">
        <div class="info-item">
          <img src="../assets/img-4.png" alt="">
          <div class="info-text">
            <div>Mobile Legends: Bang Bang</div>
            <p>A classic 5v5 battle mobile game, real-time duels between global players, rich heroes, teamwork and tactics, fast-paced competitive experience.
            </p>
          </div>
        </div>
        <div class="info-item">
          <img src="../assets/img-5.png" alt="">
          <div class="info-text">
            <div>Free Fire MAX</div>
            <p>A battle royale shooting mobile game, HD graphics and smooth operation, 100 players compete fiercely for survival in a vast map, seeking to be the last survivor.</p>
          </div>
        </div>
        <div class="info-item">
          <img src="../assets/img-6.png" alt="">
          <div class="info-text">
            <div>PUBG Mobile</div>
            <p>A battle royale shooting game, 100 players battle, providing a real combat experience, with multiple battle modes and HD maps to test players' tactics and skills.</p>
          </div>
        </div>
        <div class="info-item">
          <img src="../assets/img-7.png" alt="">
          <div class="info-text">
            <div>Genshin Impact</div>
            <p>An open world adventure RPG, explore a diverse fantasy world, immersive plot and role-playing, and feel the fun of puzzle solving and fighting.</p>
          </div>
        </div>
      </div>
    </div>


    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.home {
  min-height: 2121px;
  background: url(../assets/imag-bje.png) no-repeat;
  background-size: 100% auto;
  background-color: #01120C;

  .game-1 {
    width: 552px;
    color: #FFF;
    font-family: Helvetica;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    padding: 107px 360px;

    div {
      color: #FFF;
      font-family: Helvetica;
      font-size: 42px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
  }

  .game-list {
    margin: 40px 360px;
    padding: 90px 50px;
    background-color: #FFF;
    position: relative;

    .item-l {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-img-l {
        width: 524px;
        height: 292px;
        flex-shrink: 0;
        border-radius: 20px;
        margin-right: 30px;
      }

      .text-box {
        flex-grow: 1;
        width: 593px;
        color: #999;
        font-family: Helvetica;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;

        div {
          color: #437E38;
          font-family: Helvetica;
          font-size: 26px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: capitalize;
          margin-bottom: 28px;
        }
      }
    }

    .item-r {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 140px;

      .item-box {
        width: 524px;

        .item-img-l {
          width: 524px;
          height: 292px;
          flex-shrink: 0;
          border-radius: 20px;
          // margin-right: 30px;
        }

        .text-box {
          width: 524px;
          color: #999;
          font-family: Helvetica;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-transform: capitalize;
          margin-top: 28px;

          div {
            color: #437E38;
            font-family: Helvetica;
            font-size: 26px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            margin-bottom: 16px;
          }
        }
      }
    }

    .image-t {
      position: absolute;
      right: 123px;
      top: -400px;
      width: 320px;
    }
  }

  .game-icon {
    margin: 0px 360px;
    padding: 80px 70px;
    background-color: #FFF;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .item {
      width: 260px;
      color: #999;
      text-align: center;
      font-family: Helvetica;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
      display: flex;
      flex-direction: column;
      align-items: center;


      img {
        width: 88px;
      }

      div {
        color: #333;
        font-family: Helvetica;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-top: 40px;
        margin-bottom: 20px;
      }
    }
  }

  .game-info-box {
    margin: 40px 360px 80px 360px;
    background-color: #FFF;

    .title {
      color: #437E38;
      padding-top: 42px;
      text-align: center;
      font-size: 35px;
      font-weight: bold;
    }
  }

  .game-info {

    padding: 80px 64px;
    display: flex;
    align-items: self-start;
    justify-content: space-between;
    flex-wrap: wrap;

    .info-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 72px;

      img {
        width: 240px;
        height: 240px;
        flex-shrink: 0;
      }

      .info-text {
        width: 244px;
        margin-left: 32px;

        div {
          color: #437E38;
          font-family: Helvetica;
          font-size: 26px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: capitalize;
        }

        p {
          color: #999;
          font-family: Helvetica;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-transform: capitalize;
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
